export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes`;
export const TIMEOUT_SEC = 10;
export const RESULTS_PER_PAGE = 16;
export const API_KEY = "";
